<template>
  <div class="demo-time-range row m-0">
    <el-time-select
      v-model="time.startTime"
      class="p-0"
      :class="esDeshabilitado ? 'disabled' : ''"
      placeholder="08:00"
      start="00:00"
      :end="'23:45'"
      step="00:05"
      :disabled="esDeshabilitado"
      prefix-icon="none"
      @change="setData"
    />
    <el-time-select
      v-model="time.endTime"
      class="p-0"
      :class="esDeshabilitado ? 'disabled' : ''"
      placeholder="18:00"
      :start="'00:00'"
      end="23:45"
      step="00:05"
      :disabled="esDeshabilitado"
      prefix-icon="none"
      @change="setData"
    />
  </div>
</template>

<script>
export default {
  name: 'TimeComponent',
  props:{
    esDeshabilitado: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["get-data-horas"],
  data: function() {
        return {
            // TODO: crear variables de datos para el funcionamiento del componente
            time:{
              startTime:"",
              endTime:""
            }
        }
    },
  methods: {
    setData() {
      let time = {
        startTime: this.time.startTime.length > 0 ? this.time.startTime : "08:00",
        endTime: this.time.endTime.length > 0 ? this.time.endTime : "18:00",
      }
      this.$emit("get-data-horas", time);
    },
    CambiarHoras(horas){
      if(horas != null){
        this.time.startTime = horas.startTime
        this.time.endTime = horas.endTime
      }
    },
    Limpiar(indice){
        var inputs = document.querySelectorAll('.el-input__inner');
        console.log(inputs)
        this.time.startTime = ""
        this.time.endTime = ""
        let posicion = indice*2
        inputs[posicion].value = ""
        posicion++
        inputs[posicion].value = ""
    }
  }
}
</script>

<style scopped>

.disabled .el-select__selected-item{
  color: rgb(119, 119, 119) !important;

}

.select-trigger{
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.el-select{
  width:calc(50% - 5px) !important;
  margin-right:5px
}

.el-input{
    height: 100% !important;
    box-shadow: 0 0 5px rgba(0,0,0,0.1) !important;
    border: 2px solid #1C4F58;
    border-radius: 5px !important;
    color: #1C4F58 !important;

}

.el-icon svg path{
  fill: #1C4F58;
  height: 200px !important;
}

.el-input__inner::placeholder{
  color: #1C4F58 !important;
  -webkit-text-fill-color: #1C4F58 !important
}

.el-input__inner{
  color: #1C4F58 !important;
  -webkit-text-fill-color: #1C4F58 !important
}

.el-icon{
  width: 0px !important;
}


.el-select__wrapper{
  gap: 0px !important;
  padding: 0px !important;
  background-color: #F5F6F8 !important;
  box-shadow: none !important;
  border-radius: 8px !important;
}
.el-select__selection {
    width: 100% !important;
  }

  .el-select__selected-item{
    display: flex !important;
    justify-content: center;
    color:#011638 !important;
  }




@media screen and (max-width: 350px) {
  .agrandar .el-select{
    width: 100% !important;
    padding: 0px !important;
    margin-bottom: 15px !important;
  }
  .agrandar{
    height: 140px !important;
  }
}

@media screen and (max-width: 260px) {
  .el-select{
    width:100% !important;
    margin-right:0px;
    margin-bottom: 5px;
  }
}
</style>
